import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useActiveLeague } from "../hooks/useActiveLeague";
import { useCreateTeam } from "../api/teamsApi";
import { TeamForm } from "../components/team/TeamForm";
import posthog from 'posthog-js';

function CreateTeamPage() {
  const { activeLeague } = useActiveLeague();
  const navigate = useNavigate();
  const createTeam = useCreateTeam();
  const [searchParams] = useSearchParams();
  const leagueId = searchParams.get("leagueId");

  const handleSubmit = async (draft) => {
    const payload = {
      ...draft,
      leagueId,
      leagueSlug: activeLeague?.slug,
      leagueGameMode: activeLeague?.gameMode,
    };
    try {
      await createTeam.mutateAsync(payload);
      posthog.capture('team_created', { league_id: leagueId, league_slug: activeLeague?.slug });
      // onSuccess handler from useCreateTeam will navigate
    } catch (error) {
      console.error("Error creating team", error);
      posthog.captureException(error, { event: 'team_creation_failed' });
      alert(
        "Error saving team data: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  return (
    <div className="page-login">
      <div className="wrapper">
        <h1>CREATE TEAM</h1>
        <div className="form-block">
          <TeamForm submitLabel="SAVE" onSubmit={handleSubmit} isSubmitting={createTeam.isLoading} />
        </div>
      </div>
    </div>
  );
}

export { CreateTeamPage }; 